import ErrorUtils from '~/utils/error_utils';

export default {
    getFacebookForm(accountId = null) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/integration/facebook-form-json',
                method: 'GET',
                data: {
                    external_id: accountId
                },
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed get facebook form', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getFacebookUserAccounts() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/integration/facebook-user-accounts',
                method: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed get facebook user accounts', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    setAccountAsDefault(id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/integration/default-account',
                method: 'POST',
                data: {
                    external_user_id: id
                },
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed set default account', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getIntegration(data) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/integration/view',
                data: data,
                method: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error(xhr);
                reject(xhr);
            });
        });
    }
}

